module.exports = __webpack_public_path__ + "img/CoverStory.4b2e51cc.jpg";